<template>
  <svg width="16" height="16" viewBox="0 0 140 140">
    <g>
      <g>
        <g>
          <g>
            <path class="st0"
                  d="M135.9,110.3l-21.2-21.2c-4.2-4.2-11.2-4.1-15.6,0.3l-10.7,10.7c-0.7-0.4-1.4-0.8-2.1-1.2 c-6.7-3.7-15.9-8.8-25.6-18.5C51.1,70.6,46,61.4,42.2,54.7c-0.4-0.7-0.8-1.4-1.1-2.1l7.2-7.1l3.5-3.5c4.4-4.4,4.5-11.3,0.3-15.6 L30.9,5.2C26.7,1,19.7,1.1,15.3,5.5l-5.8,6.2c-2,2.6-3.7,5.5-4.9,8.7c-1.1,3-1.9,5.9-2.2,8.8c-2.8,23.2,7.8,44.3,36.5,73.1 c39.7,39.7,71.7,36.7,73.1,36.6c3-0.4,5.9-1.1,8.8-2.2c3.1-1.2,6.1-2.9,8.6-4.9l6.2-5.8C140,121.5,140.1,114.5,135.9,110.3z"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "svg-phone"
}
</script>

<style scoped>

</style>
